import { Fragment } from "react";

const NetworkSvg = () => {
  // Node positions
  const nodes = [
    [60, 140],
    [120, 70],
    [200, 110],
    [180, 200],
    [90, 210],
    [50, 80],   // new node
    [220, 50],  // new node
    [240, 180], // new node
    [130, 230], // new node
  ];

  // Lines connecting nodes (index references)
  const lines = [
    [0, 1],
    [1, 2],
    [2, 3],
    [3, 4],
    [4, 0],
    [0, 5], // new line
    [1, 6], // new line
    [2, 7], // new line
    [3, 8], // new line
    [5, 6], // new line
    [6, 7], // new line
    [7, 8], // new line
    [8, 5], // new line
  ];

  return (
    <Fragment>
      <svg
        width="280"
        height="280"
        viewBox="0 0 280 280"
        style={{ animation: "slowRotate 18s linear infinite" }}
      >
        {/* Connecting Lines */}
        <g stroke="#ffffff22" strokeWidth="1.5">
          {lines.map((line, i) => (
            <line
              key={i}
              x1={nodes[line[0]][0]}
              y1={nodes[line[0]][1]}
              x2={nodes[line[1]][0]}
              y2={nodes[line[1]][1]}
            >
              <animate
                attributeName="stroke-opacity"
                values="0.1;0.5;0.1"
                dur={`${2 + (i % 5) * 0.3}s`}
                repeatCount="indefinite"
              />
            </line>
          ))}
        </g>

        {/* Pulsing Nodes */}
        <g fill="#ffffff99">
          {nodes.map((p, i) => (
            <circle key={i} cx={p[0]} cy={p[1]} r="6">
              <animate
                attributeName="r"
                values="5;8;5"
                dur={`${2 + i * 0.4}s`}
                repeatCount="indefinite"
              />
              <animate
                attributeName="fill-opacity"
                values="0.4;1;0.4"
                dur={`${2 + i * 0.4}s`}
                repeatCount="indefinite"
              />
            </circle>
          ))}
        </g>
      </svg>
    </Fragment>
  );
};

export default NetworkSvg;
